/**
 * Sounds of the plains opening (data/plainsOpening.ts, played by ui/cutscene.ts): the rain on the south road, the
 * letter's paper, the red lights bursting from the town, and the flashes of the pact. Built from the kit like the
 * other scene sounds (sounds/world.ts `scene.*`).
 */
import { registerSfx } from '../registry';
import { chime, whoosh } from '../voices';

registerSfx('scene.rain', { label: 'ฝนตก (ฉาก)', cat: 'world', vary: 0.05, gap: 1.5, preview: 4 }, (k) => {
  // A wash of rain on stone and leaves, and a few heavier drops off the eaves.
  k.noise({ color: 'pink', dur: 4, vol: 0.2, attack: 1, hold: 2, f: 2400, f1: 1800, q: 0.5, trem: [7, 0.18] });
  k.noise({ dur: 3.6, vol: 0.06, attack: 0.8, f: 5200, f1: 4600, q: 1.2 });
  for (const at of [0.6, 1.4, 2.3, 3.1]) k.click({ f: 1700 + at * 140, at, vol: 0.05, q: 6, dur: 0.05 });
});

registerSfx('scene.letter', { label: 'กระดาษจดหมาย', cat: 'world', vary: 0.1, gap: 0.6, preview: 1.2 }, (k) => {
  // Paper unfolded: two dry rustles.
  k.noise({ dur: 0.22, vol: 0.12, attack: 0.02, f: 3800, f1: 2600, q: 1.4 });
  k.noise({ at: 0.28, dur: 0.3, vol: 0.09, attack: 0.04, f: 3200, f1: 4200, q: 1.2 });
});

registerSfx('scene.lights', { label: 'แสงแดงพุ่งจากศิลา', cat: 'world', vary: 0, gap: 1.5, preview: 2.6 }, (k) => {
  // A deep rise, a rush of air outward, and a high cold ring as the lights scatter.
  k.tone({ f: 70, f1: 140, dur: 1.4, vol: 0.12, attack: 0.5 });
  whoosh(k, { dur: 1.6, f0: 300, f1: 2200, f2: 900, vol: 0.18, peak: 0.6 });
  chime(k, { f: 1318.5, at: 1, vol: 0.05, dur: 1.4 });
  chime(k, { f: 1760, at: 1.2, vol: 0.035, dur: 1.2 });
});

registerSfx('scene.flash', { label: 'แสงวาบ (สัญญาเลือด)', cat: 'world', vary: 0.08, gap: 0.2, preview: 0.8 }, (k) => {
  // A bright crack and a short ring: one per flash of the vision.
  k.noise({ dur: 0.14, vol: 0.16, attack: 0.005, f: 6000, f1: 2500, q: 0.8 });
  k.thump({ f0: 120, f1: 60, dur: 0.18, vol: 0.18 });
  chime(k, { f: 987.8, at: 0.04, vol: 0.04, dur: 0.5 });
});
